export default "__VITE_PUBLIC_ASSET__59890651__"